import { useState } from "react";
import { auditService } from "../services/auditService";

const isAuthError = (err) => {
  const status = err?.response?.status;
  return status === 401 || status === 403;
};

export const useAudit = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [profitData, setProfitData] = useState(null);
  const [investmentData, setInvestmentData] = useState(null);

  // Paginated medicine state
  const [medicineData, setMedicineData] = useState({ content: [], totalElements: 0, totalPages: 0, page: 0 });

  const calculateProfit = async (fromDate, toDate) => {
    setLoading(true); setError(null);
    try {
      const data = await auditService.calculateProfitByDate(fromDate, toDate);
      setProfitData(data);
      return data;
    } catch (err) {
      if (!isAuthError(err)) { setError(err.message); throw err; }
    } finally { setLoading(false); }
  };

  const calculateTotalInvestment = async () => {
    setLoading(true); setError(null);
    try {
      const data = await auditService.calculateTotalInvestment();
      setInvestmentData(data);
      return data;
    } catch (err) {
      if (!isAuthError(err)) { setError(err.message); throw err; }
    } finally { setLoading(false); }
  };

  const calculateMedicineWiseInvestment = async (page = 0, size = 15) => {
    setLoading(true); setError(null);
    try {
      const data = await auditService.calculateMedicineWiseInvestment(page, size);
      setMedicineData({
        content: data.content ?? [],
        totalElements: data.totalElements ?? 0,
        totalPages: data.totalPages ?? 0,
        page: data.page ?? page,
      });
      return data;
    } catch (err) {
      if (!isAuthError(err)) { setError(err.message); throw err; }
    } finally { setLoading(false); }
  };

  return {
    loading,
    error,
    profitData,
    investmentData,
    medicineData,
    calculateProfit,
    calculateTotalInvestment,
    calculateMedicineWiseInvestment,
  };
};
